// TEMPORARY diagnostic instrumentation. Remove after the presence investigation.
export function presenceDiag(event, details = {}) {
  try {
    if (typeof window === 'undefined' || window.localStorage?.getItem('z10:auth_trace') !== '1') return;
    console.info('[PRESENCE-DIAG]', {
      timestamp: new Date().toISOString(), event,
      source: details.source || null, path: details.path || null, status: details.status ?? null,
      retry: details.retry ?? null, rawResponse: details.rawResponse ?? null,
      signalAborted: details.signalAborted ?? null, reason: details.reason || null,
    });
  } catch {}
}
